import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { getAppointments } from '../http/classesApi';
import { setTrainers, getSlots, getClubs } from '../http/clubsApi';
import { getCookie } from '@/utils/cookies';
import { useGetClubsQuery } from '@/queries/useGetClubsQuery';
import { useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useGetTicketsQuery } from '@/queries/useGetTicketsQuery';
import { useGetClientQuery } from '@/queries/useGetClientQuery';

export const useSignUp = () => {
  interface Club {
    id: string;
    title: string;
  }
  const queryClient = useQueryClient();
  queryClient.invalidateQueries({ queryKey: ['clubs'] });
  queryClient.invalidateQueries({ queryKey: ['appointments'] });

  const [openAccordion, setOpenAccordion] = useState('');
  const { closeAccordionState } = useSelector((state: any) => state.interfaceApp);
  useEffect(() => {
    setOpenAccordion('');
  }, [closeAccordionState]);

  const userToken: string | null = getCookie('user_token');

  const [slots, setSlots] = useState([]);
  const [slotDays, setSlotDays] = useState([]);
  const [listOfTrainers, setListOfTrainers] = useState([]);
  // Загрузка списка филиалов при монтировании

  const { data: clientData } = useGetClientQuery();
  const clubClient = useMemo<Club[]>(() => {
    if (!clientData?.club) return [];

    return [
      {
        id: clientData.club.id,
        title: clientData.club.name,
      },
    ];
  }, [clientData]);

  const { data: ticketsData } = useGetTicketsQuery();
  const clubsArr = useMemo(() => {
    if (!ticketsData) return [];
    const clubs = ticketsData.flatMap((ticket) => ticket.available_clubs || []);

    const allClubs = [...clubClient, ...clubs];
    return allClubs.filter(
      (club, index, self) => index === self.findIndex((c) => c.id === club.id),
    );
  }, [ticketsData, clubClient]);

  const [idClub, setIdClub] = useState(localStorage.getItem('id_club'));

  useEffect(() => {
    getListOfSlots();
    getFullListTrainers();
  }, [openAccordion, idClub]);

  const getListOfSlots = async () => {
    const slotDays = [];
    const resSlots = await getSlots(idClub, userToken);
    const resAppointment = await getAppointments(userToken);
    const resClubsList = await getClubs();
    const slotsArray: any[] = Object.values(resSlots);
    if (resSlots) {
      slotsArray.forEach((slot) => {
        if (slot.date_time) {
          const slotDate = slot.date_time.substring(0, 10);
          if (!slotDays.includes(slotDate)) {
            slotDays.push(slotDate);
          }
          if (slot.appointment_id) {
            resAppointment.data.data.forEach((data) => {
              if (data.appointment_id === slot.appointment_id) {
                resClubsList.data.data.forEach((club) => {
                  if (club.id === data.club_id) {
                    slot.club_title = club.title;
                  }
                });
              }
            });
          } else {
            // console.warn('Слот или date_time отсутствует:', slot);
          }
        }
      });
      setSlots(slotsArray);
      setSlotDays(slotDays);
    }
    return slotsArray;
  };
  const getFullListTrainers = async () => {
    const trainersList = [];
    const resTrainer = await setTrainers(idClub, userToken);
    if (resTrainer?.data?.data) {
      resTrainer.data.data.forEach((data) => {
        const trainer = {
          id: data.id,
          name: data.name,
          club_id: '',
        };
        if (!trainersList.some((t) => t.id === trainer.id)) {
          trainersList.push(trainer);
        }
      });
    } else {
      console.warn('Нет данных о тренерах в ответе:', resTrainer);
    }
    const resTrainersFromActiveAppointments = await getAppointments(userToken);
    if (resTrainersFromActiveAppointments?.data?.data) {
      resTrainersFromActiveAppointments.data.data.forEach((data) => {
        const trainer = {
          id: data.employee.id,
          name: data.employee.name,
          club_id: data.club_id,
        };
        if (!trainersList.some((t) => t.id === trainer.id)) {
          trainersList.push(trainer);
        }
      });
      setListOfTrainers(trainersList);
      return trainersList;
    } else {
      console.warn('Нет данных о тренерах в ответе:', resTrainersFromActiveAppointments);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return format(date, 'd MMMM', { locale: ru });
  };

  const formatDayOfWeek = (dateString) => {
    const date = new Date(dateString);
    return format(date, 'EEEE', { locale: ru });
  };

  const [selectedClubValue, setSelectedClubValue] = useState('');
  useEffect(() => {
    if (clubsArr.length > 0) {
      setSelectedClubValue(clubsArr[0].title || '');
      setIdClub(clubsArr[0].id);
    }
  }, [clubsArr]);
  return {
    selectedClubValue,
    openAccordion,
    setOpenAccordion,
    formatDate,
    formatDayOfWeek,
    setSelectedClubValue,
    getListOfSlots,
    getFullListTrainers,
    setIdClub,
    slots,
    slotDays,
    listOfTrainers,
    clubsArr,
  };
};
